import { Gift, Phone, Mail } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { TID } from "@/constants/testIds";

export const ReferralSection = () => (
  <section id="referrals" className="relative py-24 lg:py-32 bg-[#050505] overflow-hidden">
    <div className="absolute inset-0 grain" />
    <div className="max-w-6xl mx-auto px-6 lg:px-12 relative">
      <div className="card-surface rounded-3xl p-10 lg:p-16 relative overflow-hidden">
        <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[#D4AF37]/10 blur-3xl" />
        <div className="relative grid lg:grid-cols-2 gap-12 items-center">
          <Reveal direction="right">
            <div className="inline-flex items-center gap-2 overline text-[#D4AF37]">
              <Gift size={14} strokeWidth={1.5} /> Referral Reward
            </div>
            <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white leading-tight">
              Get <span className="gold-grad-text">$100</span> for every successful referral.
            </h2>
            <p className="mt-6 text-white/65 text-lg leading-relaxed max-w-lg">
              Know a property manager, leasing office, or contractor who needs better cleaning? Send them our way — once they book and complete their first job, we send you $100. No cap, no fine print.
            </p>
          </Reveal>
          <Reveal direction="left" delay={150} className="grid gap-4">
            <div className="border border-white/10 rounded-2xl p-6 bg-black/40">
              <div className="overline text-white/50 mb-2">How it works</div>
              <ol className="space-y-3 text-white/80 text-sm">
                <li className="flex gap-3"><span className="text-[#D4AF37] font-serif-display text-lg">01</span> Refer a friend or business by phone or email.</li>
                <li className="flex gap-3"><span className="text-[#D4AF37] font-serif-display text-lg">02</span> They book + complete their first cleaning.</li>
                <li className="flex gap-3"><span className="text-[#D4AF37] font-serif-display text-lg">03</span> We send you $100, that simple.</li>
              </ol>
            </div>
            <div className="flex flex-wrap gap-3">
              <a href="tel:7573542290" data-testid={TID.referralCta} className="btn-gold">
                <Phone size={16} strokeWidth={1.5} /> Call to Refer
              </a>
              <a href="#quote" className="btn-ghost"><Mail size={16} strokeWidth={1.5}/> Submit Online</a>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
